import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.replace.js";
import getProperty from "../../helpers/getProperty";
export var boxShadowRegExp = /none|inherit|initial|unset|inset/;

var boxShadowTransformation = function boxShadowTransformation(property, _ref) {
  var theme = _ref.theme,
      themeValue = _ref.themeValue;

  if (themeValue) {
    return String(themeValue);
  }

  if (typeof property === "string") {
    var _property$split$find;

    var color = (_property$split$find = property.split(" ").find(function (chunk) {
      return !boxShadowRegExp.test(chunk) && !/^\d/.test(chunk) && !/^(rgba)/.test(chunk);
    })) !== null && _property$split$find !== void 0 ? _property$split$find : null;

    if (color) {
      var _map$find;

      var themeValueColor = (_map$find = ["color", "palette"].map(function (key) {
        return getProperty(theme, "".concat(key, ".").concat(color));
      }).find(Boolean)) !== null && _map$find !== void 0 ? _map$find : null;

      if (themeValueColor) {
        property = property.replace(color, themeValueColor);
      }
    }
  }

  return String(property);
};

export default boxShadowTransformation;